import React from 'react'
import { Alert } from 'goustouicomponents/dist/Alert'
import { Column } from 'goustouicomponents/dist/Column'
import { Grid } from 'goustouicomponents/dist/Grid'
import { Heading } from 'goustouicomponents/dist/Heading'
import { Box, Heading2 } from '@gousto-internal/citrus-react'
import { ContentLoader } from '../ContentLoader'
import { Topic } from './Topic'
import css from './Topics.module.css'
import { zendeskAPI } from '../../config/routes'
import { useFetch } from '../../hooks/useFetch'
import { createSlugFromUrl } from '../../utils'

const sortCategories = (categories) => (
  categories.sort((catA, catB) => {
    if (catA.position > catB.position) {
      return 1
    }

    if (catA.position < catB.position) {
      return -1
    }

    return 0
  })
)

const Topics = () => {
  const { fetchResponse, isFetchLoading } = useFetch({ url: zendeskAPI.categories })

  const renderContent = () => {
    let categories = []

    if (fetchResponse?.categories) {
      categories = sortCategories(fetchResponse.categories)
    }

    if (isFetchLoading) {
      return <ContentLoader />
    }

    if (categories.length) {
      return (
        <Grid>
          {categories.map(({
            description,
            html_url: htmlURL,
            icon_color_light: iconColorLight,
            icon_name: iconName,
            id,
            name,
          }) => {
            const categoryNameSlug = createSlugFromUrl(htmlURL)

            return (
              <Column
                key={id}
                smallScreen={12}
                mediumScreen={6}
                largeScreen={4}
                hasPaddingSmallScreen={false}
                hasPaddingMediumScreen={false}
                hasPaddingLargeScreen={false}
                extraClass={css.column}
              >
                <Topic
                  categoryId={id}
                  categoryNameSlug={categoryNameSlug}
                  className={css.topic}
                  color={iconColorLight}
                  description={description}
                  iconName={iconName}
                  title={name}
                />
              </Column>
            )
          })}
        </Grid>
      )
    }

    return (
      <Alert type="danger">
        <Heading type="h3" size="fontStyleM">Something went wrong!</Heading>
        <p>There is an issue fetching the topics.</p>
      </Alert>
    )
  }

  return (
    <section className={css.wrapper}>
      <Box className={css.heading} paddingBottom={5}>
        <Heading2 size={4}>Browse topics</Heading2>
      </Box>
      {renderContent()}
    </section>
  )
}

export { Topics }
